import React, { memo, useCallback, useEffect } from 'react';

import _ from 'lodash';

import { useDispatch, useSelector } from 'react-redux';

import GoogleCaptcha from '../GoogleCaptcha';
import GeeTest from '../GeeTest';
import ImageCaptcha from '../ImageCaptcha';

import { useLang } from '../../hookTool';
import { ga, kcsensorsClick } from '../../common/tools';

// 校验key 常量
const geeTestKey = 'geetest';
const googleKey = 'recaptcha';
const image = 'image';
const VALIDATE_MAP = {
  [googleKey]: 'reCAPTCHA',
  [geeTestKey]: 'GEETEST',
  [image]: 'IMAGE',
};

// const sitekey = '6LdZ2ZcUAAAAANM-mSpKMEoLc4KdYbalwZ6_eJvQ';

function HumanCaptcha(props = {}) {
  const {
    sitekey = '6LccLXoUAAAAAGhhpVjsjJ6oDk_WIuG0xKGe2hzX',
    bizType,
    namespace,
    onClose,
    nowPage = '',
    isNew = false,
  } = props;

  const {
    googleCaptchaVisible,
    captchInit = {},
    imageCaptchaVisible = false,
    imgSrc = '',
    checkLoading = false,
  } = useSelector((state) => state[namespace] || {});
  const dispatch = useDispatch();

  const { captchaType = 'default', challenge = '' } = captchInit;

  const { t } = useLang();

  const handleSuccess = async (response) => {
    try {
      const { captchaType, gt, challenge } = captchInit;
      const payload = {
        bizType,
        captchaType: VALIDATE_MAP[captchaType],
        secret: gt || challenge,
        response: _.isString(response) ? response : JSON.stringify(response),
        lang: t('locale'),
      };
      // 过滤空值
      const oimtNotNull = _.omitBy(payload, (item) => {
        if (item === '' || item == null) {
          return true;
        }
        return false;
      });
      await dispatch({
        type: `${namespace}/captchaVerify`,
        payload: oimtNotNull,
      });
      dispatch({ type: `${namespace}/captchaSuccess` });
      // 成功的上报
      if (nowPage === 'signUp') {
        ga('eleClickCollectionV1', {
          str1: 'kucoinWeb',
          str2: 'kucoinWeb.register',
          str3: 'kucoinWeb.register.robotSuccess',
          str4: 'kucoinWeb.register.robotSuccess.1',
        });
        const sucEventName = isNew ? 'newRobotSuccess' : 'robotSuccess';
        kcsensorsClick([sucEventName, '1']);
      }
    } catch (err) {
      // const { msg = '', message: _msg = '' } = err || {};
      // message.error({ content: msg || _msg || '', duration: 2 });
      if (captchaType === 'image') {
        dispatch({
          type: `${namespace}/update`,
          payload: {
            checkLoading: false,
          },
        });
        dispatch({ type: `${namespace}/getImage`, payload: { challenge } });
      } else {
        dispatch({ type: `${namespace}/captchaClose` });
        handleError();
      }
      // 失败的上报
      if (nowPage === 'signUp') {
        ga('eleClickCollectionV1', {
          str1: 'kucoinWeb',
          str2: 'kucoinWeb.register',
          str3: 'kucoinWeb.register.robotfail',
          str4: 'kucoinWeb.register.robotfail.1',
        });
        const failEventName = isNew ? 'newRobotFail' : 'robotfail';
        kcsensorsClick([failEventName, '1']);
      }
    }
  };

  const handleError = () => {
    onClose && typeof onClose === 'function' && onClose();
  };

  const handleClose = () => {
    dispatch({ type: `${namespace}/captchaClose`, payload: { namespace } });
    handleError();
  };

  const imgRefresh = () => {
    dispatch({ type: `${namespace}/getImage`, payload: { challenge } });
  };

  const captchaJSX = {
    default: null,
    [geeTestKey]: (
      <GeeTest
        {...captchInit}
        onSuccess={handleSuccess}
        onClose={handleClose}
        onError={handleError}
      />
    ),
    [googleKey]: (
      <GoogleCaptcha
        {...captchInit}
        sitekey={sitekey}
        visible={googleCaptchaVisible}
        onSuccess={handleSuccess}
        onClose={handleClose}
      />
    ),
    [image]: null,
  };

  const Captcha = useCallback(() => {
    return captchaJSX[captchaType];
  }, [captchaType]);

  useEffect(() => {
    if (googleCaptchaVisible && isNew && nowPage === 'signUp') {
      kcsensorsClick(['newSignupRobotTrigger', '1']);
    }
  }, [googleCaptchaVisible, isNew]);

  return (
    <>
      <Captcha />
      <ImageCaptcha
        {...captchInit}
        visible={imageCaptchaVisible}
        imgSrc={imgSrc}
        loading={checkLoading}
        imgRefresh={imgRefresh}
        onSuccess={handleSuccess}
        onClose={handleClose}
      />
    </>
  );
}
export default memo(HumanCaptcha);
